// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__14lZr","left":"styles_left__3MKBE"};